import { type RefObject, createContext, useContext } from "react";

export type DialogAnimationContextValue = RefObject<DOMRect | null>;

export function makeDialogAnimationContext(
  originRef?: DialogAnimationContextValue,
): DialogAnimationContextValue {
  return originRef ?? { current: null };
}

export const DialogAnimationContext =
  createContext<DialogAnimationContextValue>(makeDialogAnimationContext());

export function useDialogAnimationContext() {
  return useContext(DialogAnimationContext);
}
